import api from "@/services/api"
import type { XZReport } from "@/androidPlugins/IReports"
import { BASE_Z_REPORTS_QUERY_KEY } from "@/services/queryKeys"
import { queryClient } from "@/queryClient"

export const logZReport = async (
  printable: string,
  data: XZReport
) => {
  const { body } = await api.post<{ id: string }>(
    `/devices/z-report`,
    {
      body: {
        ...data,
        receipt: printable,
      },
    }
  )
  queryClient.invalidateQueries([BASE_Z_REPORTS_QUERY_KEY])
  return body
}
